<template>
  <div>
    <div class="panel" style="margin-bottom: 20px">
      <div class="label">异动人员：</div>
      <div class="value1">{{ extra.applicant }}</div>
      <div class="label">异动日期：</div>
      <div class="value2">{{ this.detail.procStartTime }}</div>
      <div class="label">拟调出部门：</div>
      <div class="value1">{{ extra.employee.oldDeptUniqueName }}</div>
      <div class="label">拟调入部门</div>
      <div class="value2">{{ extra.applicantDeptName }}</div>
      <div class="label">原部门资产接收人</div>
      <div class="value3">
        <EmployeeSelector
          @change="handleSelectUser"
          :value="selectedUser.name ? [selectedUser] : []"
        >
          <a-button block style="text-align: left;width:200px" :disabled="detail.taskDefinitionKey !== 'asset_charger' && detail.taskDefinitionKey !== 'review_submit'">
            <div v-if="selectedUser.name">
              {{ selectedUser.name }}
            </div>
            <div v-else>&nbsp;</div>
          </a-button>
        </EmployeeSelector>
      </div>
    </div>
    <Title>固定资产清单</Title>
    <a-table bordered :dataSource="extra.fixedAssetList" :pagination="false">
      <a-table-column title="资产编码" data-index="assetCode"> </a-table-column>
      <a-table-column title="固定资产类型">
        <template slot-scope="text">
          <div style="display: flex; align-items: center" v-if="text.category">
            <DataDictFinder
              dictType="fixed_asset_type"
              :dictValue="text.category.categoryCode"
            />-
            {{ text.category.subCategoryName }}
          </div>
        </template>
      </a-table-column>
      <a-table-column title="采购日期">
        <template slot-scope="text">{{dateFormatter(text.procurementTime)}}</template>
      </a-table-column>
      <a-table-column title="处置方式" width="200px">
        <template slot-scope="text">
          <div style="display: flex; align-items: center;gap:5px">
            <span style="color: red">*</span>
            <a-select v-model="text.disposalMethod" style="width: 100%" :disabled="detail.taskDefinitionKey !== 'asset_charger' && detail.taskDefinitionKey !== 'review_submit'">
              <a-select-option value="0">带到新部门</a-select-option>
              <a-select-option value="1">移交原部门</a-select-option>
            </a-select>
          </div>
        </template>
      </a-table-column>
    </a-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getName } from "@/utils/clock";
import moment from "moment";
import EmployeeSelector from "@/components/employee-selector";
export default {
  computed: {
    ...mapState("approval", ["detail"]),
    extra() {
      return this.detail.extra
        ? {
            ...this.detail.extra,
          }
        : {};
    },
  },
  data() {
    return {
      selectedUser: {},
    }
  },
  components: {
    EmployeeSelector,
  },
  mounted() {
    if (this.extra.receiverId) {
      this.selectedUser = {
        userId: this.extra.receiverId,
        name: this.extra.receiverName,
      };
    }
  },
  methods: {
    getName,
    handleSelectUser(arr) {
      if (arr.length) {
        this.selectedUser = arr[0];
        this.detail.extra.receiverId = arr[0].userId;
        this.detail.extra.receiverName = arr[0].name;
      } else {
        this.selectedUser = {};
      }
    },
    dateFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    renderStaff(str) {
      let msg = "";
      try {
        const list = JSON.parse(str);
        msg = list.map((item) => item.userName).join("，");
      } catch (error) {
        msg = str;
      }

      return msg;
    },
  },
};
</script>

<style lang="less" scoped>
.panel {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border-top: 1px solid #e8e8e8;

  & > div {
    padding: 8px;
    border-bottom: 1px solid #e8e8e8;
  }

  .label {
    background-color: #fafafa;
    border-right: 1px solid #e8e8e8;
    border-left: 1px solid #e8e8e8;
  }

  .value1 {
    grid-column-start: 2;
    grid-column-end: 4;
  }

  .value2 {
    grid-column-start: 5;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }

  .value3 {
    grid-column-start: 2;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }
}
</style>
